import React from "react";
import { Box } from "@mui/material";
import PanelHeading, { SUBTITLE_HEIGHT } from "../Navbar/PanelHeading";
import SidebarNavList from "../Navbar/SidebarNavList";

// paletteKey matches the MUI theme.palette color group used for this status
// elsewhere in the app (see getStatusColor in BulkMessageHistoryModal.jsx),
// so broadcast statuses look the same everywhere. Kept as a colored dot
// (not swapped for an iconsax icon) -- the color itself is the meaningful
// part here, same as it always was.
export const BROADCAST_STATUS_FILTERS = [
  { key: "all", label: "All", paletteKey: null },
  { key: "draft", label: "Draft", paletteKey: "warning" },
  { key: "scheduled", label: "Scheduled", paletteKey: "info" },
  { key: "in_progress", label: "In Progress", paletteKey: "primary" },
  { key: "completed", label: "Completed", paletteKey: "success" },
  { key: "failed", label: "Failed", paletteKey: "error" },
];

// Rebuilt 2026-09-10 to match Inbox's rail exactly (same shared components as
// Settings'/Reports' sidebars) -- was its own hand-rolled ListItemButton list
// with a left-border accent instead of Inbox's background-only selection, and
// a narrower 170/190px width instead of the 280px standard.
const BroadcastSidebar = ({ selectedStatus, onSelectStatus }) => {
  const items = BROADCAST_STATUS_FILTERS.map((status) => ({
    key: status.key,
    label: status.label,
    selected: selectedStatus === status.key,
    onClick: () => onSelectStatus(status.key),
    icon: (
      <Box
        sx={{
          width: 10,
          height: 10,
          borderRadius: "50%",
          backgroundColor: (theme) =>
            status.paletteKey ? theme.palette[status.paletteKey].main : theme.palette.text.secondary,
        }}
      />
    ),
  }));

  return (
    <Box
      sx={{
        width: { xs: "100%", sm: "280px" },
        flexShrink: 0,
        height: "100%",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        backgroundColor: "background.default",
        borderRight: (theme) => `1px solid ${theme.palette.divider}`,
      }}
    >
      {/* Forced to the same fixed height as the content pane's header (which has
          a subtitle, this one doesn't) so the two bottom border lines land on
          the same pixel -- same fix as Settings'/Reports' sidebar headers. */}
      <PanelHeading title="Broadcasts" variant="narrow" sx={{ height: SUBTITLE_HEIGHT }} />
      <Box sx={{ flex: 1, minHeight: 0, overflowY: "auto" }}>
        <SidebarNavList items={items} />
      </Box>
    </Box>
  );
};

export default BroadcastSidebar;
